
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node--exhibition",
      function () {
        return require("private-next-pages/node--exhibition/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node--exhibition"])
      });
    }
  